// import * as types from '../mutation-types'
import itemService from '../api/services/freezone2022Service';
const state = {
  Process: {data: []},
  Auditors: {data: []},
  Suppliers: {data: []},
  CarMakers: {data: []},
  Models: {data: []},
  Types: {data: []},
};

const mutations = {
  setLoadedProcess (state, payload) {
    state.Process = payload;
  },
  setLoadedAuditors (state, payload) {
    state.Auditors = payload;
  },
  setLoadedSuppliers (state, payload) {
    state.Suppliers = payload;
  },
  setLoadedCarMakers (state, payload) {
    state.CarMakers = payload;
  },
  setLoadedModels (state, payload) {
    state.Models = payload;
  },
  setLoadedTypes (state, payload) {
    state.Types = payload;
  },
};

const actions = {
  Process({commit}) {
    let payload = {};
    if (localStorage.getItem ('Process')) {
      payload = JSON.parse (localStorage.getItem ('Process'));
      commit ('setLoadedProcess', payload);
      return;
    }
    payload = itemService
      .processListByParam ({
        pageNo: 1,
        rowsPerPage: -1,
        sortBy: 'ProcessName',
        descending: '',
        search: '',
      })
      .then (payload => {
        commit ('setLoadedProcess', payload.data);
        localStorage.setItem ('Process', JSON.stringify (payload.data));
      });
  },
  Auditors({commit}) {
    let payload = {};
    if (localStorage.getItem ('Auditors')) {
      payload = JSON.parse (localStorage.getItem ('Auditors'));
      commit ('setLoadedAuditors', payload);
      return;
    }
    payload = itemService
      .auditpersonListByParam ({
        pageNo: 1,
        rowsPerPage: -1,
        sortBy: '',
        descending: '',
        active: 1,
        search: '',
      })
      .then (payload => {
        commit ('setLoadedAuditors', payload.data);
        localStorage.setItem ('Auditors', JSON.stringify (payload.data));
      });
  },
  Suppliers({commit}) {
    let payload = {};
    if (localStorage.getItem ('Suppliers')) {
      payload = JSON.parse (localStorage.getItem ('Suppliers'));
      commit ('setLoadedSuppliers', payload);
      return;
    }
    payload = itemService
      .suplierListByParam2 ({
        pageNo: 1,
        rowsPerPage: 9999,
        descending: '',
        search: '',
      })
      .then (payload => {
        commit ('setLoadedSuppliers', payload.data);
        localStorage.setItem ('Suppliers', JSON.stringify (payload.data));
      });
  },
  CarMakers({commit}) {
    let payload = {};
    if (localStorage.getItem ('CarMakers')) {
      payload = JSON.parse (localStorage.getItem ('CarMakers'));
      commit ('setLoadedCarMakers', payload);
      return;
    }
    payload = itemService
      .receiveListByParam ({
        pageNo: 1,
        rowsPerPage: -1,
        descending: '',
        search: '',
      })
      .then (payload => {
        commit ('setLoadedCarMakers', payload.data);
        localStorage.setItem ('CarMakers', JSON.stringify (payload.data));
      });
  },
  Models({commit}) {
    let payload = {};
    if (localStorage.getItem ('Models')) {
      payload = JSON.parse (localStorage.getItem ('Models'));
      commit ('setLoadedModels', payload);
      return;
    }
    payload = itemService
      .modelListByParam ({
        pageNo: 1,
        rowsPerPage: -1,
        sortBy: 'Model',
        descending: '',
        search: '',
      })
      .then (payload => {
        commit ('setLoadedModels', payload.data);
        localStorage.setItem ('Models', JSON.stringify (payload.data));
      });
  },
  Types({commit}) {
    let payload = {};
    if (localStorage.getItem ('Types')) {
      payload = JSON.parse (localStorage.getItem ('Types'));
      commit ('setLoadedTypes', payload);
      return;
    }
    payload = itemService
      .typeListByParam ({
        pageNo: 1,
        rowsPerPage: -1,
        sortBy: 'EntryID',
        descending: '',
        search: '',
      })
      .then (payload => {
        commit ('setLoadedTypes', payload.data);
        localStorage.setItem ('Types', JSON.stringify (payload.data));
      });
  },
};

const getters = {
  fzProcess (state) {
    return state.Process.data;
  },
  fzAuditor (state) {
    return state.Auditors.data;
  },
  fzSupplier (state) {
    return state.Suppliers.data;
  },
  fzCarMaker (state) {
    return state.CarMakers.data;
  },
  fzModel (state) {
    return state.Models.data;
  },
  fzType (state) {
    return state.Types.data;
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
